import { Helmet } from "react-helmet-async";

interface MetaProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SITE_URL = "https://intronlifesciences.com";

export default function Meta({
  title = "Intron Life Sciences",
  description = "Intron Life Sciences is a global leader in animal health and nutrition solutions.",
  keywords = "animal health, nutrition, probiotics, poultry, aquaculture",
  image = "/img/logo.png", // Default logo if no specific image is provided
  url = typeof window !== "undefined" ? window.location.href : SITE_URL,
  type = "website",
}: MetaProps) {
  // Ensure the image URL is absolute
  const absoluteImageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{title}</title>

      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={absoluteImageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={absoluteImageUrl} />
    </Helmet>
  );
}
